module.exports = __webpack_public_path__ + "img/primary_7x4_z16.b1791e33.svg";